import React from 'react';
import useGetAddPatientParam from './useGetAddPatientParam';
import useGatherDataFromApi from 'Global/Hooks/useGatherDataFromApi';
import useGenerateFormData from './useGenerateFormData';
import { SearchPatientList } from 'Global/Adapters/SearchPatientList';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';

const useBl = (showForm, selectedPatient) => {
  const addPatientParams = useGetAddPatientParam();
  const { HandleGatherData, gatheredData } =
    useGatherDataFromApi(SearchPatientList, false, true);
  const formData = useGenerateFormData(
    addPatientParams,
    selectedPatient instanceof Object
      ? selectedPatient
      : undefined
  );

  const nationalCode_label = FindLangKey(
    'general-public-label-national-code'
  );
  const name_label = FindLangKey(
    'complete-user-input-first-name'
  );
  const family_label = FindLangKey(
    'complete-user-input-last-name'
  );
  const mobileNumber = FindLangKey(
    'general-public-mobile-number'
  );
  const patientId_label = FindLangKey(
    'new-referral-label-id'
  );
  const patientNo_label = FindLangKey(
    'lab-patient-file-number'
  );

  const searchBase_dataArray = [
    {
      ItemValue: 'NationalCode',
      ItemContent: nationalCode_label,
    },
    {
      ItemValue: 'IdPatient',
      ItemContent: patientId_label,
    },
    {
      ItemValue: 'FileNo',
      ItemContent: patientNo_label,
    },
    {
      ItemValue: 'MobileNumber',
      ItemContent: mobileNumber,
    },
    {
      ItemValue: 'Family',
      ItemContent: family_label,
    },
    {
      ItemValue: 'Name',
      ItemContent: name_label,
    },
  ];

  const initialData = [
    {
      ItemValue: nationalCode_label,
      ItemContent: nationalCode_label,
    },
  ];

  return {
    addPatientParams,
    HandleGatherData,
    formData,
    gatheredData,
    searchBase_dataArray,
    initialData,
  };
};

export default useBl;
